import { render } from "./Inplace.vue?vue&type=template&id=b8d8f6ba"
import script from "./Inplace.vue?vue&type=script&lang=js"
export * from "./Inplace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__